// extracted by mini-css-extract-plugin
export default {"container":"hs3XKftG","icon":"bbiEV6f3","title":"A1KwJMzA"};